import { Theme, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { NavMenu } from './NavMenu/NavMenu';
import { SidebarMenu } from './SidebarMenu/SidebarMenu';

export function Navigation() {
  const isMobileView = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
  const [open, setOpen] = useState(isMobileView ? false : true);

  useEffect(() => {
    if (!isMobileView) return;
    if (isMobileView) setOpen(false);
  }, [isMobileView]);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <>
      <NavMenu open={open} toggleDrawer={toggleDrawer} />
      <SidebarMenu open={open} toggleDrawer={toggleDrawer} />
    </>
  );
}
